export const iconFontAwesomeEmojiFaceFrown = (
	<i className="fa-solid fa-face-frown"></i>
);
